var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tnc-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _c("span", { staticStyle: { "font-size": "16pt" } }, [
        _vm._v("Điều khoản & Điều kiện"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Quy định chung"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Trang web của chúng tôi chỉ giới hạn cho các cá nhân trong độ tuổi hợp pháp được xác định tại khu vực pháp lý nơi cá nhân đó cư trú."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Trang web của chúng tôi không chịu trách nhiệm đối với bất kỳ luật quốc gia, luật liên bang hoặc luật quốc tế nào bị vi phạm bởi bất kỳ người dùng nào sử dụng trang web của chúng tôi."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Người dùng chịu trách nhiệm về hành động của mình và bị ràng buộc bởi luật pháp của quốc gia họ, bao gồm luật pháp tiểu bang hoặc các vấn đề pháp lý."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Tất cả các đại lý chịu trách nhiệm về tài khoản của các thành viên tương ứng của họ và sẽ tôn trọng tất cả các cược đã được xác nhận do họ gửi."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Đại lý không phải là đối tác của trang web của chúng tôi. Do đó, trang web của chúng tôi không chịu trách nhiệm về bất kỳ sự khác biệt hoặc tranh chấp nào giữa Người chơi và Đại lý."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Người dùng có trách nhiệm bảo vệ ID người dùng và Mật khẩu của mình khỏi việc sử dụng trái phép. Nếu ID người dùng và Mật khẩu của người dùng bị đánh cắp hoặc bị xâm phạm, người dùng có trách nhiệm liên hệ với đại lý của mình ngay lập tức. Sau đó, đại lý sẽ thay đổi ID người dùng và mật khẩu của người dùng."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Trong trường hợp ID người dùng và mật khẩu bị đánh cắp, người dùng phải chịu trách nhiệm về tài khoản tương ứng của mình và sẽ tôn trọng tất cả các cược đã xác nhận đã gửi."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Luật chơi game"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Kết quả trò chơi do trang web của chúng tôi quyết định sẽ là kết quả cuối cùng và mang tính ràng buộc."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Trong mọi trường hợp tranh chấp, cả ban quản lý trang web của Chúng tôi và người chơi phải đồng ý rằng cơ sở dữ liệu nhật ký giao dịch trên trang web của Chúng tôi sẽ đóng vai trò là trọng tài cuối cùng trong tranh chấp. Mọi tranh chấp phải được giải quyết trong ngày kết quả trận đấu được xác định. Không có khiếu nại nào sẽ được thực hiện sau ngày thi đấu."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Người chơi hoàn toàn chịu trách nhiệm xác minh tính chính xác của tất cả các giao dịch tài khoản của mình."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Hãy nhớ kiểm tra lại cược của bạn xem có sai sót hoặc thiếu sót nào không trước khi gửi chúng qua máy tính. Sau khi đặt cược được chấp nhận qua máy tính, nó không thể thay đổi hoặc hủy bỏ."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Chúng tôi có quyền đóng băng hoặc hủy bất kỳ tài khoản nào của khách hàng bị phát hiện vi phạm các Điều khoản và Điều kiện này, tham gia vào các hoạt động gian lận, xâm phạm, tấn công, làm sai lệch, làm hỏng các quy tắc tiêu chuẩn hoặc liên quan đến cá cược tổ hợp, dẫn đến tất cả số dư tài khoản bị đóng băng và bị tịch thu. mà không cần thông báo trước."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Chúng tôi có quyền hủy hoặc vô hiệu bất kỳ cược hoặc vé cược nào được xác định có liên quan đến cá cược theo nhóm, cá cược phối hợp, thông đồng, gian lận, lạm dụng hệ thống, lợi dụng lỗi kỹ thuật, tỷ lệ cược không chính xác hoặc bất kỳ hành vi nào khác nhằm đạt được lợi thế không công bằng. Mọi khoản tiền thắng có liên quan có thể bị thu hồi, và tài khoản liên quan có thể bị tạm khóa hoặc chấm dứt. "
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Giới hạn và trách nhiệm pháp lý"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Không ảnh hưởng đến tính tổng quát của những điều đã nói ở trên, trang web của chúng tôi sẽ không chịu trách nhiệm với bất kỳ người nào trong trường hợp phá hoại, bất khả kháng và/hoặc về các trường hợp hỏng hóc hoặc hư hỏng hoặc phá hủy hệ thống máy tính trung tâm hoặc hồ sơ hoặc bất kỳ bộ phận nào của trang web của chúng tôi. hoặc bất kỳ sự chậm trễ, mất mát, sai sót, thiếu sót hoặc bất kỳ nguyên nhân nào khác do lỗi của bất kỳ hệ thống viễn thông hoặc truyền dữ liệu nào hoặc bất kỳ sự chậm trễ nào dẫn đến việc không nhận được bất kỳ mục nào cho một cuộc đua cụ thể."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Trang web của chúng tôi sẽ không chịu trách nhiệm về bất kỳ tổn thất nào do thiên tai, bùng phát chiến sự, bạo loạn, bất ổn dân sự, hành động khủng bố, hành động của chính phủ hoặc cơ quan có thẩm quyền (bao gồm cả việc từ chối hoặc thu hồi bất kỳ giấy phép hoặc sự đồng ý nào), cháy nổ, lũ lụt, trộm cắp, phá hoại có chủ ý, đình công, bế xưởng và đình công dưới bất kỳ hình thức nào."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Trong trường hợp kết nối mạng, liên lạc, lỗi hệ thống hoặc lỗi con người gây ra các vấn đề liên quan đến đặt cược như chấp nhận cược đôi, cược không thể được xác nhận, đặt cược sau khi trận đấu bắt đầu, v.v. Chúng tôi có quyền trong trường hợp đó để giải quyết các lỗi đó trong từng trường hợp cụ thể và thực hiện bất kỳ hành động nào khác để sửa các lỗi đó. Chúng tôi sẽ không chịu bất kỳ trách nhiệm pháp lý nào đối với bạn hoặc bất kỳ bên thứ ba nào về những sai sót đó. Nếu bạn gặp phải những lỗi như vậy và tiếp tục đặt cược mà không báo cáo với tuyến trên của mình, bạn sẽ phải chịu trách nhiệm và tôn trọng mọi kết quả thắng/thua nếu lỗi xảy ra lần nữa."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Các Quy tắc và Quy định này cấu thành toàn bộ thỏa thuận và sự hiểu biết giữa các bên."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Nếu có bất kỳ sự khác biệt nào giữa phiên bản tiếng Anh của các Quy tắc và Quy định này với bất kỳ phiên bản ngôn ngữ nào khác thì phiên bản tiếng Anh sẽ thay thế các ngôn ngữ khác và được coi là chính xác và hợp lệ."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }